import { useMemoizedFn } from 'ahooks'

import { useAuthStatusEventListen } from './useAuthStatusEvents'

interface AuthStatusHandlers {
  onSwitchUser?: () => void
  onLogout?: () => void
  onLogin?: () => void
}
type AnyFunction = (...args: any[]) => any

export function useAuthStatusChange(
  fns: (AuthStatusHandlers | AnyFunction)[] = [],
) {
  const commonUpdate = useMemoizedFn(() => {
    fns.forEach((fn) => {
      if (typeof fn === 'function') {
        fn()
      }
    })
  })

  const onSwitchUser = useMemoizedFn(() => {
    commonUpdate()
    fns.forEach((fn) => {
      if (typeof fn === 'object' && typeof fn.onSwitchUser === 'function') {
        fn.onSwitchUser()
      }
    })
  })
  const onLogout = useMemoizedFn(() => {
    commonUpdate()
    fns.forEach((fn) => {
      if (typeof fn === 'object' && typeof fn.onLogout === 'function') {
        fn.onLogout()
      }
    })
  })
  const onLogin = useMemoizedFn(() => {
    commonUpdate()
    fns.forEach((fn) => {
      if (typeof fn === 'object' && typeof fn.onLogin === 'function') {
        fn.onLogin()
      }
    })
  })

  useAuthStatusEventListen({
    onLogin,
    onSwitchUser,
    onLogout,
  })
}
